import React, { useState } from "react";
import "./ContactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((previousData) => ({
      ...previousData, // keeping the data that is not edited
      //   [name] is the <input> prop (computed property, as if it was a prop in an object)
      //   { name: valueOfName }
      [name]: value, // so, if only 'message' is changed, only message: value is changed
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted! Here is your data: " + JSON.stringify(formData));

    // Using Formspree's form endpoint
    const response = await fetch("https://formspree.io/f/xdkkdqao", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setStatus("Thank you for your message!");
    } else {
      setStatus("Oops! Something went wrong.");
    }
  };

  return (
    <div className="contact-form-container">
      <form
        onSubmit={handleSubmit}
        className="contact-form"
        action="https://formspree.io/f/xdkkdqao"
        method="POST"
      >
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text" // The browser will expect this data type, so it will handle the data validation
            id="name" // DOM's unique identifier
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea // does not need the type attribute because it is a multi-line text input
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Enter your message"
            required
          ></textarea>
        </div>

        <button type="submit" className="submit-btn">
          Submit
        </button>
        {status && <p>{status}</p>}
      </form>
    </div>
  );
};

export default ContactForm;
